module.exports = __webpack_public_path__ + "img/landos-btn__bg--pink.png?22e6d68f02427001984be1e417fcea24";